// http://localhost:1002/pg/jagdeepxyza
import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { Container, Row, Col, Form, Button, Image, Table } from 'react-bootstrap';
import * as Common from '../Common';

let imgLogo = {
    height: '100px'
}

let pError = {
    color: 'red',
    fontFamily: 'Courier New',
    fontSize: '30px'
}

function Pgpine() {
    const { id } = useParams();

    const [onceRun, setOnceRun] = useState(false);
    const [trnDetail, setTrnDetail] = useState(false);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiDetails4Pg, ['details4pg', id], function (result) {
                setTrnDetail(JSON.parse(result));
                console.log(JSON.stringify(result, null, ' '));
            });
            setOnceRun(true);
        }
    }, [onceRun, id]);


    return (
        <>

            <Container>
                <Row className='justify-content-center'>
                    <div className='col-md-6'>
                        <Row>
                            <Col>

                            </Col>
                        </Row>
                        <Row>
                            <Col>&nbsp;</Col>
                        </Row>
                        <Table  >
                            <tbody>
                                <tr>
                                    <td colSpan={2} style={{ 'text-align': 'center' }}>
                                        <Image style={imgLogo} src="../img/zenith-e-remit.png" fluid />
                                    </td>
                                </tr>

                                {
                                    trnDetail.err === "" ?
                                        <>

                                            <tr>
                                                <td>Reference  : </td><td>{trnDetail.refno}</td>
                                            </tr>
                                            <tr>
                                                <td>Remitter : </td><td>{trnDetail.remittername}</td>
                                            </tr>
                                            <tr>
                                                <td>{trnDetail.isd} </td><td>{trnDetail.qty}</td>
                                            </tr>
                                            <tr>
                                                <td>Total INR : </td><td>{trnDetail.total} </td>
                                            </tr>
                                            <tr>
                                                <td>Email Id : </td><td>{trnDetail.email} </td>
                                            </tr>
                                            <tr>
                                                <td>Mobile No : </td><td>{trnDetail.mobile} </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2} >
                                                    <Form action={Common.apiPgPine} method='POST' >
                                                        <input type="hidden" name="ppc_Amount" value={(trnDetail.total) * 100} ></input>
                                                        <input type="hidden" name="ppc_UniqueMerchantTxnID" value={trnDetail.txtid} ></input>
                                                        <input type="hidden" name="ppc_CustomerMobile" value={trnDetail.mobile} ></input>
                                                        <input type="hidden" name="ppc_CustomerEmail" value={trnDetail.email} ></input>
                                                        <Row>
                                                            <Col>
                                                                <Button variant="outline-success" size="sm" type="submit" >Pay</Button>&nbsp;
                                                            </Col>
                                                        </Row>

                                                    </Form>
                                                </td>
                                            </tr>
                                        </>
                                        : <>
                                            <Row>
                                                <Col>
                                                    <p style={pError}>
                                                        <b>
                                                            <br></br>
                                                            Invalid link.
                                                            <br></br>
                                                            Please recheck the link.
                                                        </b>
                                                    </p>
                                                </Col>
                                            </Row>
                                        </>
                                }
                            </tbody>
                        </Table>

                    </div>
                </Row>

            </Container>
        </>
    )
}
export default Pgpine;
